import { UserOutlined } from '@ant-design/icons';
import { useFreshUserAttributes } from '@mm/state/hooks/use-fresh-user-attributes';
import React from 'react';
import { UserRoleContainer } from '../../../../common/hooks/use-route-guard';
import { SettingsSectionHeader } from '../common/SettingsSectionHeader/SettingsSectionHeader';
import { LiveChatPersonaPaneSection } from './LiveChatPersonaPaneSection/LiveChatPersonaPaneSection';
import './MyAccountPanel.pcss';
import { ProfilePaneSection } from './ProfilePaneSection/ProfilePaneSection';

export const MyAccountPanel = () => {
  const { areUserAttributesUptodate } = useFreshUserAttributes();
  const {
    roleFlags: { isMonitorLeadsRole },
  } = UserRoleContainer.useContainer();

  if (!areUserAttributesUptodate) {
    return null;
  }

  return (
    <div className="my-account__container">
      <SettingsSectionHeader
        title="Profile"
        color="#D4B106"
        icon={<UserOutlined />}
      >
        <ProfilePaneSection editableEmail />
      </SettingsSectionHeader>
      {!isMonitorLeadsRole && <LiveChatPersonaPaneSection />}
    </div>
  );
};
